export const INCLUDED = 'Included';
export const EXCLUDED = 'Excluded';
export const CURRENTLY_NOT = 'Currently Not';
export const ALL_NOT = 'All not';
